class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartNotif = this.closest("cart-notification");
      if (cartNotif) {
        cartNotif.deleteQuantity(this.dataset.index, 0);
      }
      const prodCard = this.closest(".cart-notification-product");
      if (prodCard) {
        prodCard.classList.add("loading");
        if (prodCard.firstElementChild) {
          prodCard.firstElementChild.classList.remove("hidden");
        }
      }
      const drawer = document.getElementById("mini-cart-drawer");
      if (drawer) drawer.classList.add("loading-bar");
    });
  }
}
customElements.define("cart-remove-button-2", CartRemoveButton2);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("mini-cart-drawer");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    if (this.notification) {
      this.notification.addEventListener(
        "keyup",
        (evt) => evt.code === "Escape" && this.close()
      );

      this.notification.addEventListener("click", (event) => {
        if (!event.target.classList.contains("cart-notification__close")) return;
        this.close();
      });
    }

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (
      !event.target.closest("select") &&
      !event.target.closest('[name="attributes[gift-wrapping]"]') &&
      !event.target.closest('[name="note"]') &&
      !event.target.closest("shipping-calculator") &&
      !event.target.closest("discount-code") &&
      !event.target.closest("gift-wrap-message")
    ) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name")
      );
      document
        .querySelector(".cart_action_drawer_overlay")
        .classList.add("active");
    }
    window.addEventListener("popstate", () => {
      if (this.notification && this.notification.classList.contains("active")) {
        this.close(true);
      }
    });

    window.addEventListener("pageshow", () => {
      document.querySelector("body")?.classList.remove("added__overlay");
    });
  }

  open() {
    this.notification.classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");

    if (!window.history.state?.cartDrawerOpen) {
      window.history.pushState({ cartDrawerOpen: true }, "", window.location.href);
    }

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close(fromPopstate = false) {
    document.getElementById("mini-cart-drawer").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    if (!fromPopstate && window.history.state?.cartDrawerOpen) {
      window.history.back();
    }

    document.body.removeEventListener("click", this.onBodyClick);
  }

  renderContents(parsedState) {
    const miniCartSection = document.getElementById("mini-cart-drawer");
    if (miniCartSection && parsedState.sections && parsedState.sections["mini-cart-drawer"]) {
      miniCartSection.innerHTML = this.getSectionInnerHTML(
        parsedState.sections["mini-cart-drawer"]
      );
    }

    let countHtml = "";
    if (parsedState.sections && parsedState.sections["cart-notification-count"]) {
      countHtml = this.getSectionInnerHTML(
        parsedState.sections["cart-notification-count"]
      ).trim();
    } else if (parsedState.item_count !== undefined) {
      countHtml = String(parsedState.item_count);
    }

    if (countHtml !== "") {
      const allCountBadges = document.querySelectorAll(
        "#cart-notification-count, #cart-notification-count-mobile, .header__actions_btn_cart_num, .mobile__nav-badge, .cart-count-bubble"
      );
      allCountBadges.forEach((badge) => {
        badge.innerHTML = countHtml;
        if (Number(countHtml) > 0) {
          badge.style.display = "";
          badge.classList.remove("d-none");
        }
      });
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "mini-cart-drawer",
      },
      {
        id: "cart-notification-count",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Cart update failed: ${response.status}`);
        }
        return response.text();
      })
      .then((state) => {
        let parsedState;
        try {
          parsedState = JSON.parse(state);
        } catch (e) {
          console.error("Malformed cart update response:", e);
          return;
        }
        this.renderContents(parsedState);
        if (parsedState.item_count > 0) {
          this.updateLiveRegions(line, parsedState.item_count);
        }
      })
      .catch((e) => {
        console.error("Cart update error:", e);
      })
      .finally(() => {
        const overlay = document.querySelector(".cart_action_drawer_overlay");
        if (overlay) overlay.classList.remove("active");
        if (this.notification) this.notification.classList.remove("loading-bar");
      });
  }
  updateLiveRegions(line, itemCount) {
    const errorEl = document.getElementById(`Line-item-error-${line}`);
    const qtyInput = document.getElementById(`Quantity-${line}`);
    if (this.currentItemCount === itemCount && errorEl && qtyInput) {
      const errorText = errorEl.querySelector(".cart-item__error-text");
      if (errorText) {
        errorText.textContent = (window.cartStrings?.quantityError || "").replace(
          "[quantity]",
          qtyInput.value
        );
      }
      errorEl.classList.remove("no-js-inline");
    } else if (errorEl) {
      errorEl.classList.add("no-js-inline");
    }
    this.currentItemCount = itemCount;
  }

  deleteQuantity(line, quantity, name) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Cart delete failed: ${response.status}`);
        }
        return response.text();
      })
      .then((state) => {
        let parsedState;
        try {
          parsedState = JSON.parse(state);
        } catch (e) {
          console.error("Malformed cart delete response:", e);
          return;
        }
        this.renderContents(parsedState);
      })
      .catch((e) => {
        console.error("Cart delete error:", e);
      })
      .finally(() => {
        const overlay = document.querySelector(".cart_action_drawer_overlay");
        if (overlay) overlay.classList.remove("active");
        if (this.notification) this.notification.classList.remove("loading-bar");
      });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    if (!html) return "";
    const doc = new DOMParser().parseFromString(html, "text/html");
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : "";
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest("cart-notification") &&
      !target.closest("#quickViewWrapper")
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);

class OpenMiniCart extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.onClickMiniCart();
    });

    this.notification = document.getElementById("mini-cart-drawer");
    this.onBodyClassRemove = this.handleBodyClass.bind(this);

    if (this.notification) {
      this.notification.addEventListener(
        "keyup",
        (evt) => evt.code === "Escape" && this.miniCartClose()
      );
    }
  }

  onClickMiniCart() {
    this.notification = this.notification || document.getElementById("mini-cart-drawer");
    if (!this.notification) return;
    this.notification.classList.add("animate", "active");
    document.body.classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClassRemove);
  }

  miniCartClose() {
    this.notification = this.notification || document.getElementById("mini-cart-drawer");
    if (this.notification) {
      this.notification.classList.remove("active");
    }
    document.body.classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClassRemove);
    const cartBtn = document.querySelector(".header__actions_btn--cart");
    if (cartBtn) removeTrapFocus(cartBtn);
  }

  handleBodyClass(evt) {
    let eventTarget = evt.target;
    //console.log(eventTarget);
    if (
      !eventTarget.closest("cart-notification") &&
      !eventTarget.closest("open-minicart") &&
      !eventTarget.closest("button")
    ) {
      this.miniCartClose();
    }
  }
}
customElements.define("open-minicart", OpenMiniCart);
